$(function($){

   /*---------------- EQUAL HEIGHT STARTS ------------------*/
  $(window).on('load', function() {   
    
   
  });

  $(window).on('resize', function() {
 
   
    
  //  equalheight('.footer-widget span.f-title');
   
  });
  /*---------------- EQUAL HEIGHT ENDS ------------------*/
  
    /*---------------- Easy Responsive Tab ------------------*/
  if ($('#parentHorizontalTab').length) {
    $('#parentHorizontalTab').easyResponsiveTabs({
      type: 'default', //Types: default, vertical, accordion
      width: 'auto', //auto or any width like 600px
      fit: true, // 100% fit in a container
      tabidentify: 'hor_1', // The tab groups identifier
      activate: function(event) { // Callback function if tab is switched
        var $tab = $(this);
        var $info = $('#nested-tabInfo');
        var $name = $('span', $info);
        $name.text($tab.text());
        $info.show();
      }
    });
  }
  /*---------------- Easy Responsive Tab ------------------*/
  
});